import StatCard from "../../components/StatCard/StatCard";
import { apiPost, apiGet } from "../../networkConfig";
import { useState, useEffect } from "react";
import PieChartData from "../../components/PieChartData/PieChartData";
import BarCharData from "../../components/BarChartData/BarChartData";
import { getString } from "../../lang";
import DataTable from "../../components/DataTable/DataTable";
import ScrollableTable from "../../components/ScrollableTable/ScrollableTable";
import MonthAndYearSelectors from "../../components/MonthAndYearSelectors/MonthAndYearSelectors";
import CustomLoader from "../../components/CustomLoader/CustomLoader";
import { capitalize } from "../../utils/helper";
import PaginationUI from "../../components/PaginationUI/PaginationUI";
import ExportToExcel from "../../components/ExportToExcel/ExportToExcel";
import Filterlist from "../../components/Filterlist/Filterlist";
import SearchUserFilter from "../../components/SearchUserFilter/SearchUserFilter";
import NoData from "../../components/NoData/NoData";
import {Button, Badge, Grid, Skeleton, Card } from "@mui/material";


const Home = () => {

    const [ analyticsData, setAnalyticsData ] = useState([]);
    const [ overAllRecommendationData, setOverAllRecommendationData ] = useState([]);
    const [ periodWiseRecommendationData, setPeriodWiseRecommendationData ] = useState([]);
    const [ monthlyRecommendationTrends, setMonthlyRecommendationTrends ] = useState([]);
    const [ expertPerformanceData, setExpertPerformanceData ] = useState({
        isLoading: true,
        rows: [],
        columns: [],
        excelColumns: []
    });

    const [ recommentdationMetrics, setRecommentdationMetrics ] = useState({
        isLoading: true,
        rows: [],
        columns: [],
        excelColumns: []
    });
    
    const [ equityRecoList, setEquityRecoList ] = useState({
        isLoading: true,
        rows: [],
        columns: [],
        excelColumns: [],
        pagination: {
            currentPage: 1,
            totalEntries: 0,
            totalPages: 0,
            entriesPerPage: 10
        }
    });

    const [ recoListFilters, selectRecoListFilter ] = useState({
        orderBy: [],
        users: []
    });

    const [ recoOrderByFilter, setRecoOrderByFilter ] = useState({});
    const [ recoUserFilter, setRecoUserFilter ] = useState([]);

    useEffect(() =>{
        getOrderByFiltersNetworkCallBack();
        getUsersFiltersNetworkCallBack();
        getAnalyticsNetworkCallBack();
        getOverAllRecommendationCountNetworkCallBack();
        getPeriodWiseRecommendationCountNetworkCallBack();
        getMonthlyRecommendationTrendsDataNetworkCallBack();
        getExpertPerformanceDataNetworkCallBack();
        getMonthlyMetricsDataNetworkCallBack();
        getRecommendationListNetworkCallback({ pageNo: 1, rowsPerPage: 10 });
    }, [])

    const getOrderByFiltersNetworkCallBack = async () => {
        try{
            let res = await apiGet("api/eqity/biz/v1/reco_filter_list");

            // console.log("getOrderByFiltersNetworkCallBack", res);

            if (res?.data?.status && Array.isArray(res?.data?.data)) {

                let filters = res.data.data.map(el=> ({ label: el.title, value: el.value }));

                selectRecoListFilter(prev => ({
                    ...prev,
                    orderBy: filters
                }))

            }else{
                selectRecoListFilter(prev => ({
                    ...prev,
                    orderBy: []
                }));
            }

        }catch(err){
            console.log("err in getOrderByFiltersNetworkCallBack", err);

            selectRecoListFilter(prev => ({
                ...prev,
                orderBy: []
            }));
        }
    };
    
    const getUsersFiltersNetworkCallBack = async () => {
        try{
            let res = await apiGet("api/user/admin/v1/expert/list?page_per_entries=50");

            if (res?.data?.status && Array.isArray(res?.data?.data)) {

                let usrs = res.data.data;

                let filters = [];

                for(let i=0; i<usrs.length; i++){
                    let obj = {
                        label: usrs[i].profile_detail.full_name,
                        value: usrs[i].profile_detail.user_profile_id
                        // srs[i].profile_detail.user_profile_id
                    }

                    filters.push(obj);
                }

                selectRecoListFilter(prev => ({
                    ...prev,
                    users: filters
                }));

            }else{
                selectRecoListFilter(prev => ({
                    ...prev,
                    users: []
                }));
            }

        }catch(err){
            console.log("err in getUsersFiltersNetworkCallBack", err);

            selectRecoListFilter(prev => ({
                ...prev,
                users: []
            }));
        }
    };
    
    const getAnalyticsNetworkCallBack = async () => {
        try{
            let res = await apiGet("api/eqity/biz/v1/stat");
            let analyticsData = [];

            if(res.data && res.data.status){
                for(let key in res.data.data){
                    let obj = {
                        title: key,
                        value: res.data.data[key] 
                    }

                    analyticsData.push(obj);
                }
                
                setAnalyticsData(analyticsData);
            }else{
                setAnalyticsData([]);
            }

        }catch(err){
            console.log("err in getAnalytics", err);
        }
    };

    const getPeriodWiseRecommendationCountNetworkCallBack = async () => {
        try{
            let res = await apiGet("api/eqity/biz/v1/period_wise/eq_stat");

            if(res.data && res.data.status){

                let recos = res.data.data;
                let recommendationData = [];
                
                recos.forEach(el => {
                    let obj = {
                        label: getString(el.duration),
                        value: el.count
                    }

                    recommendationData.push(obj);
                });

                setPeriodWiseRecommendationData(recommendationData);
            }else{
                setPeriodWiseRecommendationData([]);
            }

        }catch(err){
            console.log("err in getPeriodWiseRecommendationCountNetworkCallBack", err);
            setPeriodWiseRecommendationData([]);
        }
    };
    
    const getOverAllRecommendationCountNetworkCallBack = async () => {
        try{
            let res = await apiGet("api/eqity/biz/v1/call_stat");

            if(res.data && res.data.status){

                let recos = res.data.data;
                let recommendationData = [];
                
                Object.entries(recos).forEach(([ key, value ]) =>{
                    let obj = {
                        label: getString(key),
                        value: value
                    }
                    recommendationData.push(obj);
                })
                
                setOverAllRecommendationData(recommendationData);
            }else{
                setOverAllRecommendationData([]);
            }

        }catch(err){
            console.log("err in getOverAllRecommendationCountNetworkCallBack", err);
            setOverAllRecommendationData([]);
        }
    };

    const getMonthlyRecommendationTrendsDataNetworkCallBack = async () => {
        try{
            let res = await apiGet("api/eqity/biz/v1/monthly/trend");

            if(res.data && res.data.status){

                let recos = res.data.data;

                let monthlyTrends = [];

                recos.month_data.forEach((el, index) => {
                    let obj = {
                        month: el,
                        recos: recos.reco_data[index]
                    }

                    monthlyTrends.push(obj);
                });


                // console.log("monthlyRecosdata", monthlyTrends);

                setMonthlyRecommendationTrends(monthlyTrends);
            }else{
                setMonthlyRecommendationTrends([]);
            }
        }catch(err){
            console.log("err in getMonthlyRecommendationTrendsDataNetworkCallBack", err);
            setMonthlyRecommendationTrends([]);
        }
    };

    const getExpertPerformanceDataNetworkCallBack = async () => {
        try{
            let res = await apiGet("api/eqity/biz/v1/period_wise/expert_performance");

            let rows = [];
            let columns = [];
            let excelColumns = [];

            if(res.data && res.data.status){
                if(res.data.data && res.data.data.length){
                    rows = [
                        getString("full_name"),
                        getString("buy"),
                        getString("sell"),
                        getString("total"),
                        getString("week_performance"),
                        getString("month_performance"),
                        getString("quarter_performance"),
                        getString("long_term_performance")
                    ]

                    res.data.data.forEach(el => {
                        let columnsObj = {
                            full_name: el.expert_detail ? capitalize(el.expert_detail.full_name) : getString("unknown"),
                            buy: el.buy_call,
                            sell: el.sell_call,
                            total: el.total_call,
                            week_performance: el.week_call_performance,
                            month_performance: el.month_call_performance,
                            quarter_performance: el.quarter_call_performance,
                            long_term_performance: el.long_term_call_performance,
                        }
    
                        columns.push(columnsObj);
                    });

                    excelColumns = columns.map(el => ([
                        el.full_name,
                        el.buy,
                        el.sell,
                        el.total,
                        el.week_performance,
                        el.month_performance,
                        el.quarter_performance,
                        el.long_term_performance
                    ]));
                }else{
                    rows = [];
                    columns = [];
                }
                // console.log("rows and columns ", rows, columns);
            }

            setExpertPerformanceData(prev => ({
                ...prev,
                isLoading: false,
                rows: rows, 
                columns: columns,
                excelColumns: excelColumns
            }));

        }catch(err){
            console.log("err in getExpertPerformanceDataNetworkCallBack", err);

            setExpertPerformanceData(prev => ({
                ...prev,
                isLoading: false,
                rows: [], 
                columns: [],
                excelColumns: []
            }));
        }
    };

    const getYearAndMonth = (year, monthIndex) =>{
        if(year !== undefined && monthIndex !== undefined){
            setRecommentdationMetrics(prev => ({
                ...prev,
                isLoading: true,
                rows: [], 
                columns: [],
                excelColumns: []
            }));

            getMonthlyMetricsDataNetworkCallBack(year, monthIndex);
        }
    };

    const getMonthlyMetricsDataNetworkCallBack = async ( year, month ) => {
        try{
            let url;

            if(year !== undefined && month !== undefined){
                url = `api/eqity/biz/v1/expert/publisher/calender?month=${ month + 1 }&year=${ year }`;
            }else{
                url = `api/eqity/biz/v1/expert/publisher/calender`;
            }

            let res = await apiGet(url);

            // console.log("getMonthlyMetricsDataNetworkCallBack", res);

            let rows = [];
            let columns = [];
            let excelColumns = [];

            if(res.data && res.data.status){
                if(res.data.data && res.data.data){
                    if(res.data.data.data && res.data.data.data.length){
                        let rowData = res.data.data.data[0].reco_count;
                        let columnData = res.data.data.data;
                        
                        for(let i=0; i<rowData.length; i++){
                            rows.push(rowData[i].day);
                        }

                        let first_col = getString("full_name");

                        rows.unshift(first_col);

                        for(let i=0; i<columnData.length; i++){
                            let obj = {
                                full_name: columnData[i].expert_details ? capitalize(columnData[i].expert_details.full_name) : getString("unknown"),
                                data: columnData[i].reco_count.map(el => ( { value: el.count } ))
                            }

                            columns.push(obj);
                        }
                        
                        excelColumns = columns.map((el, i) => ([
                            el.full_name,
                            ...columnData[i].reco_count.map(el => (el.count))
                        ]));

                        // console.log("rows and columns ", rows, columns, excelColumns);
                    }
                }
            }

            setRecommentdationMetrics(prev => ({
                ...prev,
                isLoading: false,
                rows: rows, 
                columns: columns,
                excelColumns: excelColumns
            }));

        }catch(err){
            console.log("err in getMonthlyMetricsDataNetworkCallBack", err);
            setRecommentdationMetrics(prev => ({
                ...prev,
                isLoading: false,
                rows: [], 
                columns: [],
                excelColumns: []
            }));
        }
    }

    const clearFilters = () => {
        setRecoOrderByFilter({});
        setRecoUserFilter([]);

        setEquityRecoList(prev => ({
            ...prev,
            isLoading: true,
            rows: [],
            columns: [],
            excelColumns: [],

            pagination: {
                ...prev.pagination,
                currentPage: 1,
                totalEntries: 0,
                totalPages: 0,
                entriesPerPage: 10
            }
        }));

        getRecommendationListNetworkCallback({ pageNo: 1, rowsPerPage: 10 });
    }

    const handleEquityRecoListPagination = (pageObj) => {
        pageObj.orderBy = recoOrderByFilter?.value;
        pageObj.expertIds = recoUserFilter.map(el => el.value);

        getRecommendationListNetworkCallback(pageObj)
    }

     const getFiltersForRecoList = (res, filterType) => {

        setEquityRecoList(prev => ({
            ...prev,
            isLoading: true,
            rows: [],
            columns: [],
            excelColumns: [],

            pagination: {
                ...prev.pagination,
                currentPage: 1,
                totalEntries: 0,
                totalPages: 0,
                entriesPerPage: 10
            }
        }));

        if (filterType === "users") {
            setRecoUserFilter(res); // already array

            let orderByValue = recoOrderByFilter.value ? recoOrderByFilter.value : "";
            let expertIds = res.map(el => el.value).join(",");

            getRecommendationListNetworkCallback({ pageNo: 1, rowsPerPage: 10, orderBy: orderByValue, expertIds });
            
        } else {
            setRecoOrderByFilter(res); // also array (1 item)
            
            let orderByValue = res.value;
            let expertIds = recoUserFilter.map(el => el.value).join(",");

            getRecommendationListNetworkCallback({ pageNo: 1, rowsPerPage: 10, orderBy: orderByValue, expertIds });
        }
    };

    const getRecommendationListNetworkCallback = async ({ pageNo = 1, rowsPerPage = 10, orderBy, expertIds }) => {
        try{
            let url = `api/eqity/biz/v1/list?page_number=${pageNo}&page_per_entries=${rowsPerPage}`;

            if (orderBy) {
                url += `&order_by=${orderBy}`;
            }

            if(expertIds){
                url += `&expert_ids=${expertIds}`;
            }

            let res = await apiGet(url);

            let rows = [];
            let columns = [];
            let excelColumns = [];

            if(res.data && res.data.status){
                if(res.data.data && res.data.data.length){
                    rows = [
                        getString("full_name"),
                        getString("stock_name"),
                        getString("published_on"),
                        getString("period"),
                        getString("reco_price"),
                        getString("target_price"),
                        getString("stop_loss"),
                        getString("status"),
                        getString("target_period"),
                        getString("result_date_time")
                    ]

                    res.data.data.forEach(el => {
                        let columnsObj = {
                            full_name: el.expert_detail ? capitalize(el.expert_detail.full_name) : getString("unknown"),
                            stock_name: el.stock_data ? el.stock_data.name : 'NA',
                            published_on: el.created_at ? new Date(el.created_at).toLocaleString() : "NA",
                            period: el.duration,
                            reco_price: el.reco_open_price ? '₹' + el.reco_open_price : 'NA',
                            target_price: el.target_price ? '₹' + el.target_price : 'NA',
                            stop_loss: el.stop_loss,
                            status: {
                                value: el.reco_status_str == 'STOP LOSS TRIGGERED' ? 'SLT' : el.reco_status_str,
                                isTag: true,
                                color: el.reco_status_str == 'LIVE' ? "#4caf50" : el.reco_status_str == 'CLOSED' ? '#ff4560' : el.reco_status_str == 'EXIT' ? '#03a9f4' : el.reco_status_str == 'YET TO LIVE' ? '#f9ce1d' : el.reco_status_str == 'STOP LOSS TRIGGERED' ? '#ff9800' : '#3f51b5'
                            },
                            target_period: el.target_period,
                            result_date_time: el.result_date_time ? new Date(el.result_date_time).toLocaleString() : "NA",
                        };

                        columns.push(columnsObj);
                    });

                    excelColumns = columns.map(el => ([
                        el.full_name,
                        el.stock_name,
                        el.published_on,
                        el.period,
                        el.reco_price,
                        el.target_price,
                        el.stop_loss,
                        el.status?.value ?? 'NA',
                        el.target_period,
                        el.result_date_time,
                    ]));

                }else{
                    rows = [];
                    columns = [];
                }

                setEquityRecoList(prev => ({
                    ...prev,
                    isLoading: false,
                    rows: rows,
                    columns: columns,
                    excelColumns: excelColumns,

                    pagination: {
                        ...prev.pagination,
                        currentPage: pageNo || 1,
                        totalEntries: res.data.pagination?.total_entries || 0,
                        totalPages: res.data.pagination?.total_pages || 0,
                        entriesPerPage: rowsPerPage
                    }
                }));
            }else{
                setEquityRecoList(prev => ({
                    ...prev,
                    isLoading: false,
                    rows: [],
                    columns: [],
                    excelColumns: [],

                    pagination: {
                        ...prev.pagination,
                        currentPage: pageNo,
                        totalEntries: 0,
                        totalPages: 0,
                        entriesPerPage: rowsPerPage
                    }
                }));
            }
        }catch(err){
            console.log("getRecommendationListNetworkCallback", err);

            setEquityRecoList(prev => ({
                ...prev,
                isLoading: false,
                rows: [],
                columns: [],
                excelColumns: [],

                pagination: {
                    ...prev.pagination,
                    currentPage: 1,
                    totalEntries: 0,
                    totalPages: 0,
                    entriesPerPage: 10
                }
            }));
        }
    };

    // template
    return (
        <div className="main-container">
            <div className="px-4 py-4">
                <Grid container spacing={2} columns={25}>
                    {
                        analyticsData && analyticsData.length ?

                        analyticsData.map((e, index) =>{
                            return (
                                <Grid key={ index } size={{ xs: 25, sm: 12, md: 8, lg: 5, xl: 5 }}>
                                    <StatCard data={{ title: getString(e.title), value: e.value, index: index }} />
                                </Grid>
                            )
                        }) : [1,2,3,4,5,6,7,8,9,10].map((e, index) => {
                            return (<Grid key={ index } size={{ xs: 25, sm: 12, md: 8, lg: 5, xl: 5 }}>
                                <Skeleton variant="text" sx={{ fontSize: '5rem' }}></Skeleton>
                            </Grid>)
                        })
                    }
                </Grid>

                <Grid container spacing={2} columns={24} className="row-top-margin">
                    <Grid size={ { xs: 24, sm: 24, md: 24, lg: 12, xl: 12 } }>
                        <Card className='card-container p-2'>
                            <div className="text-[16px] font-semibold m-2 card-title-color">
                                { getString("recommendations_overview") }
                            </div>

                            <div className="flex flex-wrap">
                                <PieChartData data={{ recos: overAllRecommendationData, options: { innerRadius: 60, height: 300, width: 200, direction: "vertical" } }} />
                                
                                <PieChartData data={{ recos: periodWiseRecommendationData, options: { innerRadius: 60, height: 300, width: 200, direction: "vertical" } }} />
                            </div>
                        </Card>
                    </Grid>
                    
                    <Grid size={ { xs: 24, sm: 24, md: 24, lg: 12, xl: 12 } }>
                        <Card className='card-container p-2'>
                            <div className="text-[16px] font-semibold m-2 card-title-color">
                                { getString("trends") }
                            </div>

                            <BarCharData data={{ dataset: monthlyRecommendationTrends, options: { tickPlacement: "middle", labelYAxis: "", labelXAxis: "recos", height: 300, width: 40, yAxisDataKey: "recos", xAxisDataKey: "month", chartLabel: "Reco Trends", colors: ['#465fff'] } }} />
                        </Card>
                    </Grid>
                </Grid>

                <Grid container spacing={2} columns={24}>
                    <Grid size={ { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 } } className="row-top-margin">
                        <Card className='card-container p-2'>
                            <div className="text-[16px] font-semibold m-2 card-title-color flex justify-between items-center">
                                { getString("expert_performance") }

                                { (expertPerformanceData.rows && expertPerformanceData.columns) && <ExportToExcel excelRows={ expertPerformanceData.rows } excelColumns={ expertPerformanceData.excelColumns } excelName={ getString("expert_performance") } /> }
                            </div>

                            { 
                                expertPerformanceData.isLoading ? <CustomLoader noLines={[1,2,3,4,5]} variant="text" animation="wave" fontSize='2rem'></CustomLoader> : 
                            
                                expertPerformanceData.rows.length && expertPerformanceData.columns.length ?

                                <div className="row-top-margin">
                                    <DataTable row={ expertPerformanceData.rows } columns={ expertPerformanceData.columns } showNameTumbnail={ true } />
                                </div>

                                : <NoData />
                            }
                        </Card>
                    </Grid>
                </Grid>

                <Grid container spacing={2} columns={24}>
                    <Grid size={ { xs: 24, sm: 24, md: 24, lg: 24, xl: 24  } } className="row-top-margin">
                        <Card className='card-container p-2'>
                            <div className="text-[16px] font-semibold m-2 card-title-color flex justify-between items-center">
                                { getString("monthly_metric") }

                                { (recommentdationMetrics.rows && recommentdationMetrics.columns) && <ExportToExcel excelRows={ recommentdationMetrics.rows } excelColumns={ recommentdationMetrics.excelColumns } excelName={ getString("monthly_metric") } /> }
                            </div>

                            <MonthAndYearSelectors callBack={ getYearAndMonth }></MonthAndYearSelectors>

                                {
                                    recommentdationMetrics.isLoading ? <CustomLoader noLines={[1,2,3,4,5]} variant="text" animation="wave" fontSize='2rem'></CustomLoader> :

                                    recommentdationMetrics.rows.length && recommentdationMetrics.columns.length ?

                                    <div className="row-top-margin">
                                        <ScrollableTable row={ recommentdationMetrics.rows } columns={ recommentdationMetrics.columns } showNameTumbnail={ true } />
                                    </div>

                                    : <NoData />
                                }
                        </Card>
                    </Grid>
                </Grid>

                <Grid container spacing={2} columns={24}>
                    <Grid size={ { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 } } className="row-top-margin">
                        <Card className='card-container p-2'>
                            <div className="text-[16px] font-semibold m-2 card-title-color flex justify-between items-center">
                                { getString("recommendation_list") }

                                
                                <div className="flex items-center">
                                    <SearchUserFilter
                                        options={ recoListFilters.users }
                                        // multiple
                                        value={ recoUserFilter }
                                        // isSarchRequired = { true }
                                        label= {getString('select_users') } 
                                        onChange={ (res) => {
                                            getFiltersForRecoList(res, "users")
                                        } }
                                    />
                                    
                                    <Filterlist
                                        options={ recoListFilters.orderBy }
                                        value={ recoOrderByFilter }
                                        label= {getString('order_by') } 
                                        onChange={ (res) => {
                                            getFiltersForRecoList(res, "orderBy")
                                        } }
                                    />

                                    <Badge badgeContent={ recoUserFilter.length + (recoOrderByFilter?.value ? 1 : 0) } color="success">
                                        <Button
                                            variant="text"
                                            onClick={ clearFilters }
                                            sx={{ textTransform: "none", fontWeight: 500 }}
                                            >
                                            { getString("clear_filters") }
                                        </Button>
                                    </Badge>


                                    { (equityRecoList.rows && equityRecoList.columns) && <ExportToExcel excelRows={ equityRecoList.rows } excelColumns={ equityRecoList.excelColumns } excelName={ getString("recommendation_list") } styleObj={ { marginLeft: "20px" } } /> }
                                </div>
                            </div>

                            { 
                                equityRecoList.isLoading ? <CustomLoader noLines={[1,2,3,4,5]} variant="text" animation="wave" fontSize='2rem'></CustomLoader> : 

                                equityRecoList.rows.length && equityRecoList.columns.length ?
                            
                                <div className="row-top-margin">
                                    <DataTable row={ equityRecoList.rows } columns={ equityRecoList.columns } showNameTumbnail={ true } isScrollable={ true } />

                                    <div className="flex justify-end">
                                        <PaginationUI pagination={ equityRecoList.pagination } pageNo={ equityRecoList.pagination.currentPage } callBack={ (page) => handleEquityRecoListPagination(page) }  />
                                    </div>
                                </div>

                                : <NoData />
                            }
                        </Card>
                    </Grid>
                </Grid>
            </div>
        </div>
    )
}

export default Home;